module.exports = "https://coursera_assets.s3.amazonaws.com/images/09c22d07c3ab134885a5012cd7a7ddc1.png";